import { flagActions } from '../../services';

export const flagReducer = ( state = {search:false, callRemoveMethodForConfigurator:false,mobileSearchHeader:false, selectedVariable:"", isAdding:false, showSearchOverlay:false, isImporting:false, isBusy:false}, action ) => {
  switch ( action.type ) {
    case flagActions.SHOWSEARCH:
      return {...state, ["search"]:true};
    case flagActions.HIDESEARCH:
        return {...state, ["search"]:false};
    case flagActions.ENABLEREMOVEMETHODCALL:
      return {...state, ["callRemoveMethodForConfigurator"]:true, ["selectedVariable"]:action.variableName};
    case flagActions.DISABLEREMOVEMETHODCALL:
      return {...state, ["callRemoveMethodForConfigurator"]:false, ["selectedVariable"]:""};
    case flagActions.ADDING:
      return {...state, ["isAdding"]:true};
    case flagActions.NOTADDING:
      return {...state, ["isAdding"]:false};
    case flagActions.SHOWSEARCHOVERLAY:
      return {...state, ["showSearchOverlay"]:true};
    case flagActions.HIDESEARCHOVERLAY:
      return {...state, ["showSearchOverlay"]:false};
    case flagActions.SHOWMOBILESEARCHHEADER:
      return {...state, ["mobileSearchHeader"]:true};
    case flagActions.HIDEMOBILESEARCHHEADER:
      return {...state, ["mobileSearchHeader"]:false};
    case flagActions.IMPORTING:
      return {...state, ["isImporting"]:true};
    case flagActions.NOTIMPORTING: 
    return {...state, ["isImporting"]:false};
    case flagActions.BUSY: 
      return {...state, ["isBusy"]:true};
    case flagActions.NOTBUSY: 
      return {...state, ["isBusy"]:false};
    default:
      return state;
  }
};